import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5.5 12h13m-5-6.5l5 6.5m-5 6.5l5-6.5" stroke="currentColor" strokeWidth="2" fill="none" /></svg>;